export const NATCODE_CHANGE = 'NATCODE_CHANGE';
export const CLEAR_RESULTS = 'NATCODE_CHANGE';
export const NAT_CODE_CHANGE_FIRST_REG = 'NAT_CODE_CHANGE_FIRST_REG';
export const NAT_CODE_ENABLE_FIRST_REG = 'NAT_CODE_ENABLE_FIRST_REG';
export const CHANGE_BUILD_RANGE_NATCODE = 'CHANGE_BUILD_RANGE_NATCODE';
